import { RouteRecordRaw } from 'vue-router'

const ModuleRegistryPage = () =>
  import(/* webpackChunkName: "module-registry-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'modulos',
    name: 'module-registry',
    component: ModuleRegistryPage,
    meta: {
      title: 'Módulos',
      auth: {
        requiredPermission: 'module_registry.view',
        requiredModule: 'module_registry',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
